import React, { useRef, useEffect, useCallback, useState } from "react";
import { Button, Modal } from "reactstrap";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { useHistory } from "react-router-dom";

import "./ppv-follow-modal.css";
import { useNavigation } from "../../../shared/utils/useNavigation";
import { DEFAULT_USER_AVATAR, defaultProfileBanner, ROLE } from "../../../shared/constants/common";
import { nFormatter, isUserLoggedIn } from "../../../shared/utils/function.js";
import { followPPV } from "../../../shared/actions/followAction";
import { showError, showSignInRequired } from "../../../shared/utils/swalHandler";


const PPVFollowModal = ({
  modalOpen,
  toggleModal,
  creatorInfo,
}) => {
  const targetRef = useRef(null);
  const isLoggedIn = isUserLoggedIn();
  const [isFollowLoading, setIsFollowLoading] = useState(false);
  const creatorId = creatorInfo?._id;
  const history = useHistory();
  const navigate = useNavigation();

  useEffect(() => {
    const targetElement = targetRef.current;
    if (!targetElement) return;

    if (modalOpen) {
      disableBodyScroll(targetElement);
    } else {
      enableBodyScroll(targetElement);
    }

    return () => {
      enableBodyScroll(targetElement);
    };
  }, [modalOpen]);

  const handleToggleModal = useCallback(() => {
    if (toggleModal && !isFollowLoading) {
      toggleModal();
    }
  }, [toggleModal, isFollowLoading]);

  const handleFollowClick = useCallback(async () => {
    if (!creatorId) {
      return;
    }

    if (isLoggedIn) {

      setIsFollowLoading(true);
      try {
        const response = await followPPV(creatorId);
        if (response?.success) {
          toggleModal();
          history.go(0);
        } else {
          showError('Error', response?.error || 'Something went wrong. Please try again.');
        }
      } catch (error) {
        showError('Error', 'Something went wrong. Please try again.');
      } finally {
        setIsFollowLoading(false);
      }
    } else {
      showSignInRequired("follow").then((confirmed) => {
        if (confirmed) {
          navigate.toLogin();
        }
      });
    }
  }, [creatorId, history, navigate, toggleModal]);

  return (
    <Modal
      ref={targetRef}
      isOpen={modalOpen}
      toggle={handleToggleModal}
      centered
      backdrop="static"
      keyboard={true}
      className="cm_follow_info_modal modal-dialog-centered"
      style={{ overflow: "hidden" }}
    >
      <div className="row">
        <div className="subscribe-modal-left-side col">
          <div className="modal-header">
            <button
              aria-label="Close"
              className="close"
              type="button"
              onClick={handleToggleModal}
            >
              <i className="fa-solid fa-xmark"></i>
            </button>
            <img
              alt="..."
              className="profile-back"
              src={creatorInfo?.profile_banner || defaultProfileBanner}
              style={{ width: "100%", height: "140px", objectFit: "cover", objectPosition: "left center" }}
            />
            <div className="subscribe-modal-header-overlay"></div>
          </div>
          <div className="container">
            <div className="d-flex p-3">
              <div className="avatar mr-3">
                <img
                  alt="..."
                  src={creatorInfo?.profile_picture || DEFAULT_USER_AVATAR}
                />
              </div>

              <div className="owner mr-3">
                <div className="name">
                  <h5 id="pvpnameandfollower">@{creatorInfo?.username}</h5>
                  <h6 id="pvpnameandfollower">
                    <span>
                      {" "}
                      {creatorInfo?.rol === ROLE.CREATOR_CONTENT &&
                        nFormatter(
                          creatorInfo?.subscribers || 0,
                          1,
                          "Follower",
                          "Followers"
                        )}
                    </span>
                  </h6>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-body d-flex flex-column justify-content-between bt_gray">
            <h4 className="text-center mt-0">Follow Benefits</h4>
            <div className="mb-4 text-center"> @{creatorInfo?.username} </div>


            {/* Benefits List */}
            <div className="subscribe-modal-benefits">
              <div className="subscribe-modal-benefit-item">
                <div className="subscribe-modal-benefit-icon">
                  <i className="fa-solid fa-check"></i>
                </div>
                <div>
                  <p className="subscribe-modal-benefit-title">All Access Pass</p>
                  <p className="subscribe-modal-benefit-desc">Full access to this user's content</p>
                </div>
              </div>

              <div className="subscribe-modal-benefit-item">
                <div className="subscribe-modal-benefit-icon">
                  <i className="fa-solid fa-check"></i>
                </div>
                <div>
                  <p className="subscribe-modal-benefit-title">Let&apos;s Talk</p>
                  <p className="subscribe-modal-benefit-desc">Direct message with this creator</p>
                </div>
              </div>
            </div>
            <Button
              type="button"
              className="btn-round py-2 my-2 mx-auto btn btn-danger d-block w-100"
              style={{ width: "100%" }}
              onClick={handleFollowClick}
              disabled={isFollowLoading}
            >
              {isFollowLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm btn-loading-spinner"
                    role="status"
                    aria-hidden="true"
                  > </span>
                  FOLLOWING...
                </>
              ) : (
                'Follow for free'
              )}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PPVFollowModal; 